<template>
  <div class="card text-left">
    <div class="card-header bg-white py-2">
      <div class="row">
        <div class="col-8">
          <h5 class="mb-0 name">
            <b>{{ name }}</b>
          </h5>
          <span>{{ country }}</span>
        </div>
        <div class="col-4 my-auto">
          <span class="badge badge-secondary float-right">
			<i class="fal fa-clock" aria-hidden="true"></i>
            <span class="text">{{lastUpdate }} ({{ timezone }})</span>
          </span>
        </div>
      </div>
    </div>
    <div class="card-body" :style="{ backgroundImage : 'url(' + image + ')' }">
      <div class="position-relative">
        <span>
          Last input
          <b>{{ lastInput }}</b>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LocationOverview",
  props: {
    name: String,
    country: String,
    lastUpdate: String,
    lastInput: String,
    timezone: String,
    image: String
  }
};
</script>

<style scoped>
.card {
  font-size: 14px;
}

.card-body {
  height: 200px;
  background-repeat: no-repeat;
  background-position: center;
}

.card-body .position-relative span {
  font-size: 0.75rem;
  position: absolute;
  right: 0;
  color: #001d3e;
}

.name {
  font-size: 17px;
}

.badge {
  background: rgba(0, 119, 190, 0.2);
  color: #001d3e;
  font-size: 12px;
  padding: 10px 12px;
  border-radius: 6px;
}

.badge .text {
	margin-left:5px;
}

.badge i {
	font-size:14px;
	margin-bottom:-1px;
}

.position-relative {
  top: 99%;
}
</style>